import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getTaxTypesEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentTaxType`,
  });
};

export const getPricingBasisEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetPricingBasis`,
  });
};

export const getPricingTypesEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetPricingType`,
  });
};

export const getMeasurementUnitsEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetMeasurementUnit`,
  });
};

export const getLinerCodesEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetLiner`,
  });
};

export const getPaymentTypesEffects = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetPaymentType`,
  });
};
